import React from 'react';
import { testimonials } from '../data/liikunta';
export function Testimonials() {
  // Hidden until authentic IDRÆT KLAR™ reviews are added in data/idraet.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-281" data-mp="3fym68hdq8w2r">
      <div className="mx-auto max-w-6xl" data-id="element-282" data-mp="3azje1xiuikc7">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-283" data-mp="3ayhxjdj295n3">
          Det siger <em className="text-red-700" data-id="element-284" data-mp="31zwc9am7fcim">lærerne</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-285" data-mp="31yl4kzpn1km8">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-286" data-mp="2x2mmftuwkyu9">
              <div className="text-sm text-amber-500" aria-label="5 ud af 5 stjerner" data-id="element-287" data-mp="2s39qmjm20hfj">
                <span aria-hidden="true" data-id="element-288" data-mp="v85alzo35h3u">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-289" data-mp="q9tvpaixoger">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-290" data-mp="h818fqfnqklj">
                <span className="font-semibold text-slate-900" data-id="element-291" data-mp="m62p64pm27tu">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-292" data-mp="78ab7gzpprhr"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}